var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOverdueIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mission"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M32 43.9532H28V39.9688H20V43.9532H16C14.896 43.9532 14 44.8457 14 45.9454C14 47.0451 14.896 47.9376 16 47.9376H32C33.106 47.9376 34 47.0451 34 45.9454C34 44.8457 33.106 43.9532 32 43.9532Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M45.66 8.31265C45.4 9.06969 44.98 9.76697 44.38 10.3646L42.68 12.0779H44V35.9846H4V12.0779H11.44C12.16 10.5639 13.14 9.20915 14.34 8.09351H3.5C1.58 8.09351 0 9.66736 0 11.5799V36.4826C0 38.3951 1.58 39.969 3.5 39.969H44.5C46.42 39.969 48 38.3951 48 36.4826V11.5799C48 10.0658 47.02 8.77086 45.66 8.31265Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M41.8439 5.94177C41.6079 5.38594 41.0579 5.02535 40.4519 5.02933L36.9519 5.05523L36.9259 1.56885C36.9219 0.965209 36.5519 0.423326 35.9899 0.196213C35.4279 -0.0308999 34.7839 0.100587 34.3579 0.532898L29.3959 5.5493C29.1159 5.8322 28.9619 6.21271 28.9639 6.60916L28.9959 10.992C28.9779 11.008 28.9539 11.014 28.9359 11.0319L22.9799 17.0524C22.3979 17.6401 22.4059 18.5864 22.9959 19.1661C23.2919 19.455 23.6759 19.5984 24.0599 19.5964C24.4439 19.5944 24.8259 19.445 25.1179 19.1502L31.0739 13.1297C31.0919 13.1118 31.0979 13.0879 31.1139 13.0699L35.5139 13.038C35.9119 13.0361 36.2919 12.8747 36.5719 12.5918L41.5339 7.57539C41.9559 7.14308 42.0799 6.49959 41.8439 5.94177Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M33.8179 16.0405H32.3979L30.0179 18.451C29.8579 21.5788 27.2779 24.0492 24.0979 24.0691C20.7779 24.1089 18.0779 21.4394 18.0379 18.1522C18.0179 14.9647 20.4979 12.3548 23.6379 12.1357L25.9779 9.76497V8.31065C25.3179 8.19111 24.6579 8.13135 23.9779 8.13135C18.4579 8.19111 13.9979 12.6736 14.0379 18.1721C14.0979 23.6706 18.6179 28.0934 24.1179 28.0535C29.6379 28.0137 34.0979 23.5113 34.0379 18.0327C34.0379 17.3553 33.9579 16.678 33.8179 16.0405Z",
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOverdueIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/overdueIcon.6980eb33f4f318696de1e601de2e5778.svg";